import * as React from 'react'
import {
    InputRnnFieldSecure,
    InputSecureFieldRef,
} from 'app/shared/components/InputRnnSecureField'
import { Button } from 'primereact/button'
import { InputSecureField } from 'app/shared/components/InputSecureField'
import Loader from 'app/shared/layouts/loader/Loader'
import { BlockUI } from 'primereact/blockui'
import {
    useLazySelectCom0203Query,
    Com0203CtlrIn,
} from 'app/core/services/com/com.service'
import {
    InputDLSecureField,
    InputDLSecureFieldRef,
} from 'app/shared/components/InputDriverSecureField'
import { createBrowserHistory } from 'history'
import { useLocation } from 'react-router-dom'

export type InputResultType = 'hidden' | 'success' | 'error'
const PgInputSecure: React.FC = () => {
    const [ready, setReady] = React.useState(false)
    const [loading, setLoading] = React.useState(false)
    const rnnRef = React.useRef<InputSecureFieldRef>(null)
    const ref0 = React.useRef<InputSecureFieldRef>(null)
    const ref1 = React.useRef<InputSecureFieldRef>(null)
    //비활성화 테스트
    const [disabled, setDisabled] = React.useState(false)
    //초기값 변경 테스트
    const [aValue, setAValue] = React.useState('')
    //서버에 보내서 테스트
    const checkPin0Ref = React.useRef<InputSecureFieldRef>(null)
    const checkPin1Ref = React.useRef<InputSecureFieldRef>(null)
    //운전면허
    const dlRef = React.useRef<InputDLSecureFieldRef>(null)
    const [isResult, setIsResult] = React.useState<InputResultType>('hidden')
    const [isResultMsg, setIsResultMsg] = React.useState<string>('')
    const [isResultId, setIsResultId] = React.useState<string>('')

    /**
     * 라이브러리 로드를 위한 Delay
     */
    React.useEffect(() => {
        const delay = setTimeout(() => {
            setReady(true)
        }, 3000)
        return () => clearTimeout(delay)
    }, [])

    React.useEffect(() => {
        //(필수)native input field가 생성된 이후 호출해야함.
        if (ready) globalThis.initmTranskey()
    }, [ready])

    const history = createBrowserHistory()
    const location = useLocation()

    /**
     * 값 비교
     */
    const [fetch] = useLazySelectCom0203Query()
    const handleCheck = () => {
        //클라이언트 체크 시
        const pin0 = checkPin0Ref.current.getData()
        const pin1 = checkPin1Ref.current.getData()

        //서버 체크시
        setLoading(true)
        globalThis.mtk.fillEncData()
        const securePin0 = checkPin0Ref.current.getSecureData()
        //서버가 계속 N만 반환하여 테스트 해봄..
        // const securePin1 = checkPin1Ref.current.getSecureData()
        const securePin1 = securePin0

        const send: Com0203CtlrIn = {
            pwd1: securePin0.transkeyPwd,
            pwd1Id: securePin0.id,
            pwd1InitTime: securePin0.initTime,
            pwd1KeyboardType: securePin0.keyboardType,
            pwd1KeyIndex: securePin0.keyIndex,
            pwd1FieldType: securePin0.fieldType,
            pwd1SeedKey: securePin0.seedKey,
            pwd1TransKey: securePin0.transkeyPwd,
            pwd1TransKeyHm: securePin0.transkeyHM,

            pwd2: securePin1.transkeyPwd,
            pwd2Id: securePin1.id,
            pwd2InitTime: securePin1.initTime,
            pwd2KeyboardType: securePin1.keyboardType,
            pwd2KeyIndex: securePin1.keyIndex,
            pwd2FieldType: securePin1.fieldType,
            pwd2SeedKey: securePin1.seedKey,
            pwd2TransKey: securePin1.transkeyPwd,
            pwd2TransKeyHm: securePin1.transkeyHM,
            pwdLength: 0,
        }
        fetch(send)
            .then(({ data }) => {})
            .finally(() => {
                setLoading(false)
            })
    }
    //--면허 번호 변경 테스트
    const [no0, setNo0] = React.useState('00')
    const [no1, setNo1] = React.useState('0')
    const [no2, setNo2] = React.useState('0')
    const [no3, setNo3] = React.useState('0000')
    const [no4, setNo4] = React.useState('00')
    const [no5, setNo5] = React.useState('0')
    const [no6, setNo6] = React.useState('0')

    const changeDLNumber = () => {
        setNo0('00')
        setNo1('0')
        setNo2('0')
        setNo3('0000')
        setNo4('00')
        setNo5('0')
        setNo6('0')
    }

    if (!ready) {
        return <Loader />
    }

    return (
        <React.Fragment>
            <BlockUI blocked={loading} fullScreen />
            <p>
                화면에 점이 찍히고 나면 사용을 시작합니다.(로드 못하는 js파일
                문제)
            </p>
            <br />
            <div>주민번호 입력(props가 대부분 고정됨)</div>
            <InputRnnFieldSecure
                showGender={true}
                ref={rnnRef}
                onChange={(rnn1: string, rnn2: string) => {}}
                onClose={(rnn1: string, rnn2: string) => {}}
                result="hidden"
                resultId="rnnerror"
                resultMsg="주민번호가 틀렸슴돠"
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="로그로 비문출력"
                onClick={() => {}}
            />
            <br />
            <InputSecureField
                ref={ref0}
                id="uuid"
                type="number"
                maxLength={4}
                label="[테스트]4자 비밀번호"
                result="error"
                resultMsg="테스트 에러 메시지 입니다."
                onChange={(value: string) => {}}
                onClose={(value: string) => {}}
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="로그로 비문출력"
                onClick={() => {}}
            />
            <br />
            <InputSecureField
                ref={ref1}
                id="uuid2"
                type="qwerty"
                maxLength={6}
                label="[테스트]6자 문자"
                onChange={(value: string) => {}}
                onClose={(value: string) => {}}
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="로그로 비문출력"
                onClick={() => {}}
            />
            <br />
            <InputSecureField
                id="noid"
                type="number"
                maxLength={4}
                label="[테스트]disabled"
                {...{ disabled }}
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="비활성화 toggle"
                onClick={() => {
                    setDisabled(!disabled)
                }}
            />
            <br />
            <InputSecureField
                id="noid2"
                type="number"
                maxLength={4}
                label="[테스트]초기값 변경"
                onChange={(value) => {
                    setAValue(value)
                }}
                value={aValue}
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="''으로 초기화"
                onClick={() => {
                    setAValue('')
                }}
            />
            <br />
            <InputSecureField
                ref={checkPin0Ref}
                id="checkpin0"
                type="number"
                maxLength={4}
                label="[테스트]입력값1"
                onClose={(value, isFulfilled) => {
                    if (isFulfilled) checkPin1Ref.current.focus()
                }}
            />
            <InputSecureField
                ref={checkPin1Ref}
                id="checkpin1"
                type="number"
                maxLength={4}
                label="[테스트]입력값2"
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="입력값 비교"
                onClick={handleCheck}
            />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="필드 초기화"
                onClick={() => {
                    checkPin0Ref.current.clear()
                    checkPin1Ref.current.clear()
                }}
            />
            <br />
            <br />
            <div className="field">
                <InputDLSecureField
                    result="success"
                    resultMsg=""
                    resultId=""
                    ref={dlRef}
                    no0={no0}
                    no1={no1}
                    no2={no2}
                    no3={no3}
                    no4={no4}
                    no5={no5}
                    onChange={(no1, no2, no3, no4, no5, no6) => {
                        setNo0(no1)
                        setNo1(no2)
                        setNo2(no3)
                        setNo3(no4)
                        setNo4(no5)
                        setNo5(no6)
                    }}
                    onClose={(no1, no2, no3, no4, no5, no6) => {
                        if (no1.length < 1) {
                            setIsResult('error')
                            setIsResultMsg(
                                '운전면허번호가 맞지 않습니다. 확인해주세요.'
                            )
                            setIsResultId('error_no1')
                            return
                        }
                        if (no2.length < 1) {
                            setIsResult('error')
                            setIsResultMsg(
                                '운전면허번호가 맞지 않습니다. 확인해주세요.'
                            )
                            setIsResultId('error_no2')
                            return
                        }
                        if (no3.length < 6) {
                            setIsResult('error')
                            setIsResultMsg(
                                '운전면허번호가 맞지 않습니다. 확인해주세요.'
                            )
                            setIsResultId('error_no3')
                            return
                        }
                        if (no4.length < 1) {
                            setIsResult('error')
                            setIsResultMsg(
                                '운전면허번호가 맞지 않습니다. 확인해주세요.'
                            )
                            setIsResultId('error_no4')
                            return
                        }
                        if (no5.length < 1) {
                            setIsResult('error')
                            setIsResultMsg(
                                '운전면허번호가 맞지 않습니다. 확인해주세요.'
                            )
                            setIsResultId('error_no5')
                            return
                        }
                    }}
                />
            </div>
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="로그로 비문출력"
                onClick={() => {}}
            />
            <br />
            <Button
                className="button-basic-tint -md width-full mt-24"
                label="값 변경 테스트"
                onClick={() => {
                    changeDLNumber()
                }}
            />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <p>키패드 스크롤은 어찌해야할지...</p>
            <br />
        </React.Fragment>
    )
}
export default PgInputSecure
